import React from "react";
import RlAuxiliaryAnalysisInfoTooltip from "../../../components/RlAuxiliaryAnalysisInfoTooltip";

const RLAuxiliaryAnalysisLabel = () => (
  <span className="integrations__rl-cloud-sandbox-label">
    <img src="/static/images/rl-logo-square.svg" /> Auxiliary Analysis{" "}
    <RlAuxiliaryAnalysisInfoTooltip />
  </span>
);

RLAuxiliaryAnalysisLabel.toString = () => "RL Auxiliary Analysis";

export default RLAuxiliaryAnalysisLabel;
